import { render, staticRenderFns } from "./replyDetail.vue?vue&type=template&id=efb8d436&scoped=true"
import script from "./replyDetail.vue?vue&type=script&lang=js"
export * from "./replyDetail.vue?vue&type=script&lang=js"
import style0 from "./replyDetail.vue?vue&type=style&index=0&id=efb8d436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb8d436",
  null
  
)

export default component.exports